(function () {
    'use strict';
    angular.module('app').controller('TransitWarrantyReportsController', TransitWarrantyReportsController);
    TransitWarrantyReportsController.$inject = [
        'TransitWarrantyService',
        '$q',
        '$filter',
        'toastr',
        'TransitWarrantyReportedClaimsTableService',
        'TransitWarrantyAdditionalCoverageTableService',
        'scrollToForm',
        '$cookies'
    ];

    function TransitWarrantyReportsController(
        TransitWarrantyService,
        $q,
        $filter,
        toastr,
        TransitWarrantyReportedClaimsTableService,
        TransitWarrantyAdditionalCoverageTableService,
        scrollToForm,
        $cookies
    ) {
        const vm = this;

        vm.toggleFromDatepicker = toggleFromDatepicker;
        vm.toggleToDatepicker = toggleToDatepicker;
        vm.setToDatepickerOptions = setToDatepickerOptions;
        vm.setFromDatepickerOptions = setFromDatepickerOptions;
        vm.generateReports = generateReportsBtnClick;
        vm.exportReportToCSV = exportReportToCSVBtnClick;
        vm.exportReportToPDF = exportReportToPDFBtnClick;

        init();

        async function init() {
            vm.filters = { reportType: 'withReportedClaims', inclusiveDates: 'monthly' };
            initTables();
            generateReportsData();
        }

        function initTables() {
            vm.reportedClaimsTable = new TransitWarrantyReportedClaimsTableService([]);
            vm.reportedClaimsTableData = vm.reportedClaimsTable.tableData;
            vm.additionalCoverageTable = new TransitWarrantyAdditionalCoverageTableService([]);
            vm.additionalCoverageTableData = vm.additionalCoverageTable.tableData;
        }

        function setFromDatepickerOptions() {
            vm.fromDatepickerOptions = {
                maxDate: vm.filters.toDate,
                initDate: new Date()
            }
        }

        function setToDatepickerOptions() {
            vm.toDatepickerOptions = {
                minDate: vm.filters.fromDate,
                initDate: new Date()
            }
        }

        function toggleFromDatepicker() {
            vm.isFromDatepickerOpen = !vm.isFromDatepickerOpen;
        }

        function toggleToDatepicker() {
            vm.isToDatepickerOpen = !vm.isToDatepickerOpen;
        }

        function generateReportsBtnClick(form) {
            form.$setSubmitted();
            if (form.$invalid) {
                scrollToForm(form.$name);
                return false;
            }

            generateReportsData();
        }

        function exportReportToPDFBtnClick(form) {
            form.$setSubmitted();
            if (form.$invalid) {
                scrollToForm(form.$name);
                return;
            }

            const filter = generateDateRageFilter();
            filter.reportType = angular.getObjVal(vm.filters, 'reportType') === 'additionalCoverage' ? 'AdditionalCoverage' : 'ReportedClaims';

            vm.exportingToPDF = true;
            TransitWarrantyService.Claims.exportToPDF(data => {
                vm.exportingToPDF = false;
                toastr.success('Report successfully exported to pdf', 'Success');
            }, error => {
                vm.exportingToPDF = false;
                toastr.error(error.message, 'Error');
            }, filter);
        }

        function exportReportToCSVBtnClick(form) {
            form.$setSubmitted();
            if (form.$invalid) {
                scrollToForm(form.$name);
                return;
            }

            const filter = generateDateRageFilter();
            filter.reportType = angular.getObjVal(vm.filters, 'reportType') === 'additionalCoverage' ? 'AdditionalCoverage' : 'ReportedClaims';

            vm.exportingToCSV = true;
            TransitWarrantyService.Claims.exportToCSV(data => {
                vm.exportingToCSV = false;
                toastr.success('Report successfully exported to csv', 'Success');
            }, error => {
                vm.exportingToCSV = false;
                toastr.error(error.message, 'Error');
            }, filter);

        }

        function generateReportsData() {
            vm.loading = true;
            vm.additionalCoverageTable.toggleLoadingIndicator(vm.loading);
            vm.reportedClaimsTable.toggleLoadingIndicator(vm.loading);

            const filters = generateFilterData(vm.filters);
            const resellerId = $cookies.get('resellerId');

            TransitWarrantyService.Claims.report(data => {
                const reports = data;
                vm.loading = false;
                setupTableData(reports);

            }, error => {
                toastr.error(error.message, 'Error');
            }, filters, resellerId);
        }
        
        function generateFilterData(filters) {
            if (filters.inclusiveDates === 'range') {
                return generateDateRageFilter();
            }
            return { startDate: null, endDate: null }
        }

        function generateDateRageFilter() {
            return {
                startDate: angular.getObjVal(vm.filters, 'fromDate') ? moment(vm.filters.fromDate).format('MM-DD-YYYY') : null,
                endDate: angular.getObjVal(vm.filters, 'toDate') ? moment(vm.filters.toDate).format('MM-DD-YYYY') : null
            };
        }

        function setupTableData(reports) {
            if (vm.filters.reportType === 'withReportedClaims') {
                showWithReportedClaimsData(reports);
                return;
            }

            if (vm.filters.reportType === 'additionalCoverage') {
                showAdditionalCoverageReport(reports);
            }
        }

        function showWithReportedClaimsData(reports) {
            vm.withReportedClaims = true;
            vm.reportedClaimsTable.updateTableData(reports.data);
            vm.reportedClaimsTable.toggleLoadingIndicator(vm.loading);
            vm.reportedClaimsTableData = vm.reportedClaimsTable.tableData;
            vm.total = vm.reportedClaimsTable.totalClaimAmount();
            vm.enableConvertButton = reports.data.length > 0;
        }

        function showAdditionalCoverageReport(reports) {
            vm.withReportedClaims = false;
            vm.additionalCoverageTable.updateTableData(reports.data);
            vm.additionalCoverageTable.toggleLoadingIndicator(vm.loading);
            vm.additionalCoverageTableData = vm.additionalCoverageTable.tableData;
            vm.total = vm.reportedClaimsTable.totalClaimAmount();
            vm.enableConvertButton = reports.data.length > 0;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/transit-warranty/TransitWarrantyReportsController.js